import { isDate } from 'date-fns'
import { isEmpty } from 'lodash'
import {
  getFormAsyncErrors,
  getFormValues,
  stopAsyncValidation,
} from 'redux-form'
import * as Effects from 'redux-saga/effects'
import selectReservationTab from '../../../actions/bookingCalendar/reservationModal/selectReservationTab'
import validateReservation, {
  IValidateReservation,
} from '../../../actions/bookingCalendar/reservationModal/validateReservationForm'
import fireToastError from '../../../actions/toasts/fireToastError'
import { Errors } from '../../../containers/Form/CreateReservation/validate'
import i18n from '../../../i18n'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'
import { validEmail } from '../../../utils/Validation'

function* changeTab(action: IValidateReservation) {
  yield Effects.put(selectReservationTab(Math.min(...action.tabs)))
}

export function* validate(
  formName: 'create_reservation' | 'update_reservation',
) {
  const errorTabs = new Set<number>()
  const formErrors = yield Effects.select(getFormAsyncErrors(formName))
  if (!isEmpty(formErrors)) {
    if (formErrors.dateTo && formErrors.dateFrom) {
      yield Effects.put(
        fireToastError(
          i18n.t('reservation_reserved_date_error'),
          5000,
          'Event',
          'reservationDateReservedError',
        ),
      )
      errorTabs.add(0)
    } else if (formErrors.dateTo && !formErrors.dateFrom) {
      yield Effects.put(
        fireToastError(
          i18n.t('reservation_no_date_error'),
          5000,
          'Event',
          'reservationDateEmptyError',
        ),
      )
      errorTabs.add(0)
    } else if (formErrors.adultsCount) {
      yield Effects.put(
        fireToastError(
          i18n.t('reservation_error_wrong_number_of_people'),
          5000,
          'Event',
          'reservationPeopleNumberError',
        ),
      )
      errorTabs.add(0)
    } else if (formErrors.roomId) {
      yield Effects.put(
        fireToastError(
          i18n.t('BBO_963_select_room'),
          5000,
          'Event',
          'reservationNoRoomError',
        ),
      )
      errorTabs.add(0)
    } else if (formErrors.email) {
      yield Effects.put(
        fireToastError(
          i18n.t('reg_error_email_not_email'),
          5000,
          'Event',
          'reservationEmailError',
        ),
      )
      errorTabs.add(1)
    }
    yield Effects.put(validateReservation([...errorTabs]))
    return formErrors
  }

  const values = yield Effects.select(getFormValues(formName))

  const { roomId, adultsCount, dateTo, guest } = values
  const errors: Errors = {}
  if (!roomId || isEmpty(roomId)) {
    errors.roomId = i18n.t('BBO_963_select_room')
    errorTabs.add(0)
  }
  if (!adultsCount || adultsCount === 0) {
    errors.adultsCount = i18n.t('reservation_error_wrong_number_of_people')
    errorTabs.add(0)
  }
  if (!isEmpty(guest.email) && !validEmail(guest.email)) {
    errors.guest = {
      email: i18n.t('reg_error_email_not_email'),
    }
    errorTabs.add(1)
  }
  if (!isDate(dateTo)) {
    errors.dateTo = i18n.t('reservation_no_date_error')
    yield Effects.put(
      fireToastError(
        i18n.t('z677_date_to_not_empty'),
        null,
        'Event',
        'reservationDateEmptyError',
      ),
    )
    errorTabs.add(0)
  }

  if (isEmpty(errors)) {
    return null
  } else {
    if (errors.adultsCount && !errors.dateTo) {
      yield Effects.put(
        fireToastError(
          i18n.t('reservation_error_wrong_number_of_people'),
          null,
          'Event',
          'reservationPeopleNumberError',
        ),
      )
    } else if (
      errors &&
      errors.roomId &&
      !(errors.dateTo || errors.adultsCount)
    ) {
      yield Effects.put(
        fireToastError(
          i18n.t('BBO_963_select_room'),
          null,
          'Event',
          'reservationNoRoomError',
        ),
      )
    }
    yield Effects.put(stopAsyncValidation(formName, errors))
    yield Effects.put(validateReservation([...errorTabs]))
    return errors
  }
}

export default function* () {
  yield Effects.takeLatest(ReservationModalActions.Validate, changeTab)
}
